import {merge_normal_and_special_hours, weekdays, timeConvert} from "../helpers";

export default {
  template: '#vue-store-location',
  delimiters: ['${', '}'],
  props: {
    place_: Object,
    store_number: String,
    init_store: Number
  },
  data() {
    if (this.place_) {
      return {
        place: this.place_,
        featured_store: true,
        active_tab: false
      }
    } else {
      return {
        place: null
      };
    }
  },
  computed: {
    latitude() {
      if (this.place !== null) {
        return this.place.latitude
      }
      return null
    },
    longitude() {
      if (this.place !== null) {
        return this.place.longitude
      }
      return null
    },
    hours() {
      if (this.place === null) {
        return null
      }
      if (this.place.opening_hours) {
        const store_hours = merge_normal_and_special_hours(this.place.opening_hours, this.place.special_hours)
        if (!store_hours){
          return null
        }
        return store_hours.map((hours, index) => {
          let dow_str = weekdays[this.$store.state.lang]()[index]
          if (hours.start && hours.end) {
            return `${dow_str}: ${timeConvert(hours.start)} - ${timeConvert(hours.end)}` + (hours.special ? "*" : '')
          } else {
            return `${dow_str}: ${(this.$store.state.lang === 'en' ? 'CLOSED' : 'FERMÉ')}` + (hours.special ? "*" : '')
          }
        });
      }
      return null
    },
    has_special_hours() {
      if (this.hours) {
        for (let hour of this.hours) {
          if (hour.endsWith("*")) {
            return true
          }
        }
      }
      return false
    },
    directions_url() {
      if (this.formatted_address !== null) {
        return `https://www.google.com/maps/dir//${this.formatted_address}`
      }
      return null
    },
    formatted_address() {
      if (this.place !== null) {
        return `${this.place.address}, ${this.place.city}, ${this.place.province}`
      }
      return null
    },
    distance() {
      if (this.place !== null) {
        let distance = Math.round((this.place.distance + Number.EPSILON) * 10) / 10
        return (distance > 100 ? Math.round(distance) : distance)
      }
      return null
    }
  },
  methods: {
    staticmap_url(store_number) {
      return `${window.fileUrlPrefix}staticmap-${store_number}.png`
    },
    activateLocation(isStatic) {
      if (isStatic) {
        this.$store.commit("setActiveStaticStore",
            (this.place.store_number === this.$store.state.active_static_store ? null : this.place.store_number)
        )
      } else {
        this.$store.state.global_components.map.activeLocation(this.place.store_number, true);
      }
    },
  },
  mounted: function () {
    if (!this.place) {
      this.$store.dispatch('getLocation')
      .then(
          success => {
            this.$store.dispatch('getAllStores').then(
                resp => {
                  this.place = this.$store.getters.store_info(this.store_number)
                },
                () => {
                })
          },
          () => {
          }
      )
    }
  }
}